// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Guidelines-NoWorkToDo-NoWorkToDo-module__zeroStateMessage";
export { _1 as "zeroStateMessage" }
